// Salaries Management Permissions

export const SALARIES_INDEX = 136;
export const SALARIES_CREATE = 137;

// ⚠️ RECONCILE BEFORE RELEASE — see src/permissions/payroll.js for why.
// Registered by database/migrations/2026_09_05_000005_add_salaries_print_permission.php;
// 1531 is counted forward from the confirmed 1522 — derived, not read.
//
//     SELECT id FROM permissions WHERE name = 'salaries.print';
export const SALARIES_PRINT = 1531;
